<div class="level-progress-bar" *ngIf="UserService.user">

    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div *ngFor="let level of levels" class="level">
        <img [src]="level.image" [class.completed]="level['completed']">
      </div>
    </div>

    <div class="bar gray" #graybar></div>
    <div class="bar orange" [style.width]="orange_length"></div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
    style="margin-top: 15px;">
      <div class="status_text">
        <div>Du hast aktuell {{UserService.user.bonus_points}} Woodcoins.</div>
        <div>Bis zum nächsten Level fehlen {{points_missing_to_next_level}} Woodcoins.</div>
      </div>
      <img style="height: 30px;" class="woodcoin" [src]="environment.publicFolder+'assets/images/woodcoin.svg'">
    </div>

</div>